















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'MyApproval'
})
export default class extends Vue {
  showNav = true
}
